import React from 'react';
import {i18n} from '@lingui/core';

import {AppUrls} from 'shared/config/model/urls';
import {Pages} from 'shared/config/model/pages';
import HttpMonitorLogRow from 'features/http/ui/HttpMonitor/HttpMonitorLogs/HttpMonitorLogRow';
import ListPage from 'shared/ui/ListPage/ListPage';
import ListToolbar from 'shared/ui/ListToolbar/ListToolbar';
import TableToolbar from 'shared/ui/TableToolbar/TableToolbar';
import useOpenState from 'shared/lib/hooks/useOpenState';
import {
    getHttpMonitorLogColumns,
    getHttpMonitorLogTitle,
    stripMonitorUrlScheme,
} from 'features/http/lib/httpMonitorLogView';
import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';
import useHttpMonitorLogs from 'features/http/model/useHttpMonitorLogs';

import HttpMonitorFiltersModalLog from './HttpMonitorsFiltersLog/HttpMonitorFiltersModalLog';

import styles from './HttpMonitorLogs.module.scss';

interface IHttpMonitorLogsProps {
    monitor: IHttpMonitorItem,
}

const HttpMonitorLogs: React.FC<IHttpMonitorLogsProps> = ({monitor}) => {
    const {pagination, isLoading, isFetching, refetch, dateRange, tzString} = useHttpMonitorLogs(monitor.uuid, true);
    const filter = useOpenState();

    return (
        <ListPage
            documentTitle={getHttpMonitorLogTitle(monitor.name)}
            toolbar={
                <ListToolbar
                    title={i18n._(Pages.HTTP_MONITOR_LOG)}
                    backUrl={AppUrls.HTTP_MONITORS}
                    summary={<span className={styles.name}>{stripMonitorUrlScheme(monitor.name)}</span>}
                    actions={
                        <TableToolbar
                            onFilter={filter.open}
                            onRefresh={refetch}
                            isRefreshing={isFetching}
                        />
                    }
                />
            }
            actions={<div className={styles.dateRangeInfo}>{dateRange}</div>}
            columns={getHttpMonitorLogColumns()}
            items={pagination?.items}
            rowFactory={item => <HttpMonitorLogRow
                key={item.checked_at}
                item={item}
                tzString={tzString}
            />}
            isLoading={isLoading}
            pagination={pagination}
        >
            <HttpMonitorFiltersModalLog open={filter.isOpen} handleClose={filter.close}/>
        </ListPage>
    );
};

export default HttpMonitorLogs;
